import React, { useState } from 'react';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import ActionMenu from '../../../../components/ui/materialui/actionMenu';
import { Delete, Download, Send } from '@mui/icons-material';
import { ListaMINVU } from './modalListadoMinvu';
import { actualizarEstado, deleteListMinvu } from '../service/servicesComunMINVU';
import { EstadoSubsidioMinvu, StatusCode, TipoArchivo } from '../../../../utils/enums';
import { ArgumentosEstado } from './models/listaModel';
import { useToast } from '../../../../hooks/useToast';
import { descargarExcelCobroMinvu, descargarExcelValidacionMinvu, descargarTxtCobroMinvu, descargarTxtValidacionMinvu } from '../../../detalleMutuo/services/servicesReportes';

interface IProps {
    data: ListaMINVU;
    renderizar: () => void;
    tipoArchivo: string;
}

const AccionesList: React.FC<IProps> = ({ data, renderizar, tipoArchivo }) => {
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const { addToast } = useToast();

    const handleDescargar = async () => {

        switch (tipoArchivo) {
            case TipoArchivo.TIPOARCHIVOMINVU_COBRO:
                await handleDescargarCobro();
                break;
            case TipoArchivo.TIPOARCHIVOMINVU_VALIDACION:
                await handleDescargarValidacion();
                break;
            default:
                return;
        }

        if (data.estado === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_ENVIADO)
            return;

        const dataRequest: ArgumentosEstado = {
            idEnvio: data.idArchivo,
            estado: EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_DESCARGADO
        }

        const resp = await actualizarEstado(dataRequest)
        if (resp.status === StatusCode.Ok) {
            renderizar();
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Se ha descargado correctamente'
            });
        }
    }

    const handleDescargarValidacion = async () => {
        await descargarExcelValidacionMinvu(data.idArchivo, data.nombreArchivo);
        await descargarTxtValidacionMinvu(data.idArchivo, data.nombreArchivo);
    }

    const handleDescargarCobro = async () => {
        await descargarExcelCobroMinvu(data.idArchivo, data.nombreArchivo);
        await descargarTxtCobroMinvu(data.idArchivo, data.nombreArchivo);
    }

    const handleEnviar = async () => {
        const dataRequest: ArgumentosEstado = {
            idEnvio: data.idArchivo,
            estado: EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_ENVIADO
        }

        const resp = await actualizarEstado(dataRequest)
        if (resp.status === StatusCode.Ok) {
            renderizar();
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Se ha enviado correctamente'
            });
        }
    }

    const handleEliminarListado = async () => {

        setModalConfirmacion({
            show: true,
            title: "Eliminar listado",
            message: "¿Desea eliminar el listado MINVU?",
            metodo: async () => {
                const resp = await deleteListMinvu(data.idArchivo, tipoArchivo)
                if (resp.status === StatusCode.NoContent) {
                    renderizar();
                    addToast({
                        mostrar: true,
                        titulo: 'Confirmación',
                        tipo: 'Success',
                        mensaje: 'Se ha eliminado correctamente'
                    });
                }
            },
        });

    }

    const actions = [
        {
            label: 'Descargar',
            icon: <Download fontSize="small" />,
            onClick: handleDescargar,
        },
        {
            label: 'Enviar',
            icon: <Send fontSize="small" />,
            onClick: handleEnviar,
        },
        {
            label: 'Eliminar listado',
            icon: <Delete fontSize="small" />,
            onClick: handleEliminarListado,
        }

    ];

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            <ActionMenu actions={actions} />
        </>

    );
};

export default AccionesList;
